"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedirectActionEnum = void 0;
var RedirectActionEnum;
(function (RedirectActionEnum) {
    RedirectActionEnum["ResetPassword"] = "reset-password";
    RedirectActionEnum["ConfirmEmail"] = "confirm-email";
})(RedirectActionEnum = exports.RedirectActionEnum || (exports.RedirectActionEnum = {}));
//# sourceMappingURL=redirect-action-enum.js.map